
import Base from '../components/Base/Base';
import CommitteeContent from '../components/Committee/CommitteeContent';


const Committee = () => {
    return(
        <Base>
        <CommitteeContent/>
        </Base>
    )
}

export default Committee;